/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

import { halfGutterSize, profileGridSizeTimes, responsiveThreshold } from '../constants';

/**
 * Top level content layout component.
 * There should only be one.
 * Contains and arranges a column of Sections.
 */
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Body = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	min-height: calc(100vh - 56px);

	/* Max content width: 1000px */
	max-width: ${profileGridSizeTimes(14)}px;

	/* center */
	margin: 0 auto;

	/**
   * Set a 20px horizontal padding to produce a full 40px between a
   * column's content and the edge of the page when added to the column's padding
   */
	padding: 0 ${halfGutterSize}px;

	@media (max-width: ${responsiveThreshold}px) {
		padding: 0 ${token('space.300', '24px')};
	}

	padding-bottom: ${token('space.400', '32px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyOld = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	min-height: calc(100vh - 56px);

	/* Max content width: 1000px */
	max-width: ${profileGridSizeTimes(12.5)}px;

	/* center */
	margin: 0 auto;

	/**
   * Set a 20px horizontal padding to produce a full 40px between a
   * column's content and the edge of the page when added to the column's padding
   */
	padding: 0 ${halfGutterSize}px;

	@media (max-width: ${responsiveThreshold}px) {
		padding: 0 ${token('space.300', '24px')};
	}

	padding-bottom: ${token('space.400', '32px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WideBody = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	min-height: calc(100vh - 56px);

	/* Max content width: 1000px */
	max-width: ${profileGridSizeTimes(18)}px;

	/* center */
	margin: 0 auto;

	/**
   * Set a 20px horizontal padding to produce a full 40px between a
   * column's content and the edge of the page when added to the column's padding
   */
	padding: 0 ${halfGutterSize}px;

	@media (max-width: ${responsiveThreshold}px) {
		padding: 0 ${token('space.300', '24px')};
	}

	padding-bottom: ${token('space.400', '32px')};
`;
